import { depositBankingDetailsHeaders, withdrawalBankingDetailsHeaders } from "./constants";
import { createEditDepositBankingDetailsSchema, createEditWithdrawalBankingDetailsSchema } from "./schema";

const getBankingDetailsValidationSchema = (bankType) => {
  if (bankType === "deposit") {
    return createEditDepositBankingDetailsSchema;
  } else {
    return createEditWithdrawalBankingDetailsSchema;
  }
}

const getBankingDetailsHeaders = bankType => {
  if (bankType === "deposit") {
    return depositBankingDetailsHeaders;
  } else {
    return withdrawalBankingDetailsHeaders;
  }
}

export {
  getBankingDetailsValidationSchema,
  getBankingDetailsHeaders
}

export const getBankingDetailsInitialValues = (bankType, data) => {
  if (bankType === "deposit") {
    return {
      bankName: data?.bankName || "",
      accountHolderName: data?.accountHolderName || "",
      accountNumber: data?.accountNumber || "",
      accountType: data?.accountType || "SAV",
      rtNumber: data?.rtNumber || "",
      place: data?.place || "",
      status: data?.status || false,
    };
  } else {
    return {
      bankName: data?.bankName || "",
      rtNumber: data?.rtNumber || "",
      status: data?.status || false,
    };
  }
}
